import RevieveSDK from '../../../src/RevieveSDK';

require('popper.js');
require('bootstrap/dist/css/bootstrap.min.css');
require('bootstrap/dist/js/bootstrap.min.js');
require('jquery.json-viewer/json-viewer/jquery.json-viewer.js');

require('jquery.json-viewer/json-viewer/jquery.json-viewer.css');
require('../css/test.css');

const configuration = {
  partnerID: 'VweadehMqO',
  userID: 'revieve-sdk-demouser',
};
let revieveSDK;
let productCategories = [
  'Face Mask',
  'Eye Mask',
  'Cleanser',
  'Serum',
  'Moisturizer',
  'Night Cream',
  'Toner',
  'Exfoliator',
  'Blush',
  'Lipstick',
  'Foundation',
];

window.onLoadActions = () => {
  // eslint-disable-next-line no-undef
  Sentry.init({ dsn: 'https://0184b8fc4bdc4d03800a5aba4c1c7f70@sentry.io/1436419' });

  revieveSDK = new RevieveSDK(configuration.partnerID, true);
  revieveSDK.setUserId(configuration.userID);
  loadOptionsIntoSelects();
};

let loadOptionsIntoSelects = () => {
  for (let gender in RevieveSDK.gender) {
    if (RevieveSDK.gender[gender]) {
      $('#selectGender').append(
        $('<option>', {
          value: RevieveSDK.gender[gender],
          text: gender.toUpperCase(),
        }),
      );
    }
  }
  for (let skinType in RevieveSDK.skinTypes) {
    if (RevieveSDK.skinTypes[skinType]) {
      $('#selectSkintype').append(
        $('<option>', {
          value: RevieveSDK.skinTypes[skinType],
          text: skinType.toUpperCase(),
        }),
      );
    }
  }
  for (let hairColor in RevieveSDK.hairColor) {
    if (RevieveSDK.hairColor[hairColor]) {
      $('#selectHairColor').append(
        $('<option>', {
          value: RevieveSDK.hairColor[hairColor],
          text: hairColor.toUpperCase(),
        }),
      );
    }
  }
  for (let eyeColor in RevieveSDK.eyeColor) {
    if (RevieveSDK.eyeColor[eyeColor]) {
      $('#selectEyeColor').append(
        $('<option>', {
          value: RevieveSDK.eyeColor[eyeColor],
          text: eyeColor.toUpperCase(),
        }),
      );
    }
  }
  productCategories.map((category) =>
    $('#selectProductCategories').append(
      $('<option>', {
        value: category,
        text: category.toUpperCase(),
      }),
    ),
  );
};

const sdkMethodMap = {
  userId: { method: 'setUserId', type: 'text' },
  gender: { method: 'setGender', type: 'text' },
  age: { method: 'setAge', type: 'text' },
  hairColor: { method: 'setHairColor', type: 'text', requiredTag: false },
  eyeColor: { method: 'setEyeColor', type: 'text', requiredTag: false },
  skintone: { method: 'setSkintone', type: 'range', requiredTag: false },
  wrinkles: { method: 'setWrinkles', type: 'range' },
  eyebags: { method: 'setEyebags', type: 'range' },
  darkSpots: { method: 'setDarkSpots', type: 'range' },
  cuperose: { method: 'setCuperose', type: 'boolean', additional: true },
  rocasea: { method: 'setRocasea', type: 'boolean', additional: true },
  acne: { method: 'setAcne', type: 'boolean', additional: true },
  eczema: { method: 'setEczema', type: 'boolean' },
  hyperpigmentation: { method: 'setHyperpigmentation', type: 'boolean', additional: true },
  oilyness: { method: 'setOilyness', type: 'boolean', additional: true },
  dullTired: { method: 'setDullTired', type: 'boolean', additional: true },
  psoriasis: { method: 'setPsoriasis', type: 'boolean', additional: true },
  organic: { method: 'setOrganic', type: 'boolean', additional: true },
  vegan: {method: 'setVegan', type: 'boolean', additional: true },
  antiAge: { method: 'setAntiAge', type: 'boolean', additional: true },
  fragranceFree: { method: 'setFragranceFree', type: 'boolean', additional: true },
  parabenFree: { method: 'setParabenFree', type: 'boolean', additional: true },
  sunProtection: { method: 'setSunProtection', type: 'boolean', additional: true },
  skinBrightening: { method: 'setSkinBrightening', type: 'boolean', additional: true },
  skinFirming: { method: 'setSkinFirming', type: 'boolean', additional: true },
  skinType: { method: 'setSkintype', type: 'text' },
  productCategories: { method: 'setCategories', type: 'array' },
};

let callSDKMethod = (id, value, requiredTag = false, variantName = null) => {
  let methodName = sdkMethodMap[id].method;
  revieveSDK[methodName].call(revieveSDK, value, requiredTag, variantName);
};

$('#getProductButton').click(function (e) {
  e.preventDefault();
  const productId = $('#inputProductId').val();
  if (!productId) return;
  $('#modalLoading').modal('toggle');
  revieveSDK.PR.getProduct(productId)
    .then((productInfo) => {
      setTimeout(() => $('#modalLoading').modal('toggle'), 500);
      $('#json-renderer').jsonViewer(productInfo || {});
    })
    .catch((error) => {
      console.error(error);
      $('#modalLoading').modal('toggle');
      $('#modalError').modal('toggle');
    });
});

$('#filterValues').submit(function (e) {
  e.preventDefault();
  $('#modalLoading').modal('toggle');
  let formValues = $('#filterValues').serializeArray();
  // we add the unchecked checkbox to form serialization
  formValues = formValues.concat(
    $('#filterValues input[type=checkbox]:not(:checked)')
      .map(function () {
        return { name: this.name, value: 'off' };
      })
      .get(),
  );
  let arraysFound = [];
  let requiredTag = $('#inputMandatory')[0].checked;
  if (!requiredTag) {
    revieveSDK._state.configuration.requiredTags = null;
  }
  // we set the values in SDK state
  for (const formValue of formValues) {
    if (formValue.name === 'mandatory') {
      continue;
    }
    let value = formValue.value;
    if (sdkMethodMap[formValue.name].type === 'range') {
      value /= 100;
      if (formValue.name === 'skintone') {
        value = parseInt(5 * value + 1, 10);
      }
    }

    if (sdkMethodMap[formValue.name].type === 'boolean') {
      value = formValue.value === 'on' ? 1 : 0;
    }

    if (sdkMethodMap[formValue.name].type === 'array') {
      if (arraysFound.indexOf(formValue.name) < 0) {
        arraysFound.push(formValue.name);
      }
    } else {
      callSDKMethod(formValue.name, value, sdkMethodMap[formValue.name].additional ? requiredTag : false);
    }
  }
  arraysFound.map((arrayFound) => {
    let values = [];
    formValues.map((formValue) => {
      if (formValue.name === arrayFound) {
        return values.push(formValue.value);
      }
      return true;
    });
    return callSDKMethod(arrayFound, values);
  });

  revieveSDK.PR.getRecommendedProducts()
    .then((products) => {
      setTimeout(() => $('#modalLoading').modal('toggle'), 500);
      $('#json-renderer').jsonViewer(products);
      $('#historyId').val(revieveSDK.PR.getHistoryId());
    })
    .catch((error) => {
      console.error(error);
      $('#modalLoading').modal('toggle');
      $('#modalError').modal('toggle');
    });
});

$('#clearFilters').on('click', () => {
  revieveSDK.clearUIConfiguration();
  $('#filterValues').trigger('reset');
});

$('#inputFile').change(function (e) {
  e.preventDefault();
  let file = $('#inputFile')[0].files[0];
  if (file) {
    $('#modalLoading').modal('toggle');
    revieveSDK.CV.setImage(file)
      .then(() => {
        revieveSDK.CV.analyzeImage()
          .then(() => {
            let state = revieveSDK.getState();
            $('#rangeWrinklesCV').val(state.configuration.wrinkles_cv * 100);
            $('#rangeEyebagsCV').val(state.configuration.eyebags_cv * 100);
            $('#rangeRednessCV').val(state.configuration.redness_cv * 100);
            $('#CVSkinDetected')[0].style = 'display: inline';
            $('#modalLoading').modal('toggle');
          })
          .catch((error) => {
            $('#modalLoading').modal('toggle');
            if (error.message) {
              alert(error.message);
            }
          });
      })
      .catch((error) => {
        $('#modalLoading').modal('toggle');
        if (error.message) {
          alert(error.messagge);
        }
      });
  }
});
